import React, { useEffect } from "react";
import { SearchableDropdown } from "components";
import styled from "styled-components";
import colors from "theme/colors";
import PropertySearchDropdown from "./PropertySearchDropDown.component";
import { useRulesTableContext } from "../../pages/ProductDetail/ProductLineRulesTables/RulesTableContext";

export default function RulesTableSearchInput({
  filteredOptionsFormatted,
  newProperty,
  type,
  setSelectedProperty,
  setSelectedPva,
}: {
  filteredOptionsFormatted?: any;
  newProperty?: any;
  type: "property" | "pva";
  setSelectedProperty?: any;
  setSelectedPva?: any;
}) {
  useEffect(() => {
    if (newProperty) setSelectedProperty(newProperty.value);
  }, []);

  const handleChange = (e) => {
    if (type === "property") {
      setSelectedProperty(e);
      setSelectedPva(null);
    }

    if (type === "pva") {
      setSelectedPva(e);
    }
  };

  const rulesetFilter = useRulesTableContext().rulesets.map(
    (ruleset) => ruleset?.name
  );

  return (
    <>
      {type === "property" && (
        <StyledPropertySearchComponent
          placeholder={"select property"}
          multiselect={false}
          onChange={handleChange}
          name="addNewProperty"
          rulesetFilter={rulesetFilter}
        />
      )}
      {type === "pva" && (
        <StyledPVASearchableDropdown
          multiselect={false}
          searchable
          clearable
          options={filteredOptionsFormatted}
          value={
            filteredOptionsFormatted.find(
              (option) => option.value === newProperty
            ) ?? null
          }
          placeholder={"select pva"}
          handleValueChange={(e) => handleChange(e)}
          name="addNewPropertyPVA"
          noHoverBorder
        />
      )}
    </>
  );
}

const StyledPVASearchableDropdown = styled(SearchableDropdown)`
  .MuiAutocomplete-inputRoot {
    border: 1px solid ${colors.tables.borders} !important;
    height: 32px !important;
  }

  .MuiAutocomplete-inputRoot,
  .MuiAutocomplete-inputRoot .MuiAutocomplete-input {
    box-shadow: none !important;
    background-color: ${colors.tables.columnsAndRowsTitles} !important;
    font-size: 12px !important;
    font-weight: 700 !important;
  }

  .MuiAutocomplete-input {
    padding-left: 16px !important;
  }
`;

const StyledPropertySearchComponent = styled(PropertySearchDropdown)<any>`
  > div > div > input {
    background-color: ${colors.tables.columnsAndRowsTitles} !important;
    box-shadow: none !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    height: 32px !important;
    border: 1px solid ${colors.tables.borders} !important;
  }
`;
